import { Anchor } from '@klaviyo-mkt/gatsby-components/atoms/anchor';
import styled from 'styled-components';

import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';

import TopicsMenuWithData from '../../../components/topics-menu';

export const SectionPage = styled.div``;

export const ParentLink = styled(Anchor)`
  position: relative;
  &:first-of-type {
    padding-left: 3.2rem;
  }
  &:first-of-type&::before {
    bottom: 0;
    content: '←';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 2.4rem;
  }
`;

export const SectionName = styled(Typography)`
  h1 {
    display: inline;
    font: inherit;
    line-height: inherit;
  }
`;

export const SectionDescription = styled(Typography)``;

export const SectionMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const Articles = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;

export const ArticleLink = styled(Anchor)`
  color: ${({ theme }) => theme.colors.charcoal};
  font-size: 1.8rem;
  text-underline-offset: 0.1em;
  
  &:hover {
    color: ${({ theme }) => theme.colors.charcoal};
  }
`;

export const StyledTopicsMenu = styled(TopicsMenuWithData)`
  flex-shrink: 0;
`;

export const Content = styled.div``;
export const SubSectionContent = styled.div`
  padding-bottom: 3.6rem;
  ${ArticleLink}{
    padding: 1.6rem 3.6rem 0;
    display: block;
  }
`;
export const SubSectionTitleLink = styled(Anchor)`
  text-decoration: none;
`;
